// DO NOT CONVERT TO TS AS THIS IS CALLED BY serverSideRendering.js
/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatic from 'hoist-non-react-statics';

import UserAgent from './UserAgent';

export { UserAgent };

export const windowStr = typeof window === 'undefined' ? '' : window.navigator.userAgent;

export class UserAgentProvider extends React.Component<{
  userAgentSpec: string,
  children: React.Node,
}> {
  static defaultProps: {
    userAgentSpec: string,
    children: React.Node,
  };

  static childContextTypes = {
    userAgent: PropTypes.instanceOf(UserAgent),
  };

  getChildContext() {
    const { userAgentSpec } = this.props;

    return {
      userAgent: new UserAgent(userAgentSpec),
    };
  }

  render() {
    return this.props.children;
  }
}

export function withUserAgent<Props: {}>(WrappedComponent: React.ComponentType<Props>) {
  function WithUserAgent(props: Props, context: Object) {
    const { userAgent } = context;
    return <WrappedComponent {...props} userAgent={userAgent} />;
  }

  WithUserAgent.contextTypes = {
    userAgent: PropTypes.instanceOf(UserAgent),
  };

  // $FlowFixMe property `displayName` not found in Component object type
  WithUserAgent.displayName = `withUserAgent(${WrappedComponent.displayName})`;

  return hoistNonReactStatic(WithUserAgent, WrappedComponent);
}

export default new UserAgent(windowStr);
